import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Section } from '../catalog-manager.models';
import { getImageUrl } from '../catalog-manager.utils';

@Component({
  selector: 'app-section-box',
  templateUrl: './section-box.component.html',
  styleUrls: ['./section-box.component.scss']
})
export class SectionBoxComponent {
  @Input() section!: Section;
  @Input() isSelected: boolean = false;
  @Input() hasChildren: boolean = false;
  @Input() childCount: number = 0;
  @Input() itemCount: number = 0;
  @Input() isEditing: boolean = false;
  @Input() editingName: string = '';
  @Input() markedItemIds: Set<number> = new Set();
  @Input() isSpecial: boolean = false; // For unsectioned items section

  @Output() navigate = new EventEmitter<void>();
  @Output() dragStart = new EventEmitter<DragEvent>();
  @Output() dragOver = new EventEmitter<DragEvent>();
  @Output() drop = new EventEmitter<DragEvent>();
  @Output() addItem = new EventEmitter<Event>();
  @Output() addSection = new EventEmitter<Event>();
  @Output() markAllItems = new EventEmitter<Event>();
  @Output() copyMarkedItems = new EventEmitter<Event>();
  @Output() moveMarkedItems = new EventEmitter<Event>();
  @Output() edit = new EventEmitter<Event>();
  @Output() delete = new EventEmitter<Event>();
  @Output() editSave = new EventEmitter<String>();
  @Output() editCancel = new EventEmitter<void>();
  @Output() editInputClick = new EventEmitter<Event>();

  failedImages = new Set<number>();
  getImageUrl = getImageUrl;

  hasValidImage(): boolean {
    return !this.failedImages.has(this.section.id);
  }

  onImageError(event: Event) {
    const img = event.target as HTMLImageElement;
    const urlMatch = img.src.match(/images\/(\d+)_main/);
    if (urlMatch) {
      const id = parseInt(urlMatch[1], 10);
      this.failedImages.add(id);
    }
    img.style.display = 'none';
  }

  onNavigate() {
    this.navigate.emit();
  }

  onDragStart(event: DragEvent) {
    this.dragStart.emit(event);
  }

  onDragOver(event: DragEvent) {
    this.dragOver.emit(event);
  }

  onDrop(event: DragEvent) {
    this.drop.emit(event);
  }

  onAddItem(event: Event) {
    this.addItem.emit(event);
  }

  onAddSection(event: Event) {
    this.addSection.emit(event);
  }

  onMarkAllItems(event: Event) {
    this.markAllItems.emit(event);
  }

  onCopyMarkedItems(event: Event) {
    this.copyMarkedItems.emit(event);
  }

  onMoveMarkedItems(event: Event) {
    this.moveMarkedItems.emit(event);
  }

  onEdit(event: Event) {
    this.edit.emit(event);
  }

  onDelete(event: Event) {
    this.delete.emit(event);
  }

  onEditSave() {
    this.editSave.emit(this.editingName);
  }

  onEditCancel() {
    this.editCancel.emit();
  }

  onEditInputClick(event: Event) {
    this.editInputClick.emit(event);
  }

  getTotalCount(): number {
    return this.childCount + this.itemCount;
  }
}
